import { SORT_BY } from '@web-platform/shared-universal-constants/src/queryParams';
import { parseSortOption } from '@web-platform/shared-universal-utils-frontend/src/helpers/parseSortOption';
import { GLOBAL } from 'saddlebag-browser';

import { SORT_SELECTED } from '../../../../../actions/sort';

import type { SortTypes } from '@web-platform/shared-universal-constants/src/sort';
import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { SelectedSortState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/sort/sort';

function getInitialState(): SelectedSortState {
  const $window = GLOBAL.getWindow();
  let sortBy: string | undefined;
  if (typeof $window?.location?.search === 'string') {
    const params = new URLSearchParams($window.location.search.toLowerCase());
    sortBy = params.get(SORT_BY) || undefined;
  }
  return parseSortOption(sortBy);
}

const selectedSort = (state: SortTypes = getInitialState(), action: Action): SelectedSortState => {
  switch (action.type) {
    case SORT_SELECTED:
      return action.payload.order;

    default:
      return state;
  }
};
export const get = (state: SortTypes): SelectedSortState => state;
export default selectedSort;
